<template>
  <!--  :style="{minWidth:isMobile?'1920px':''}"-->
  <div id="app">
    <Header></Header>
    <router-view :key="$route.fullPath" />
    <div
      class="modal fade"
      tabindex="-1"
      style="background: #ffffff"
      :class="{ show: store.isLoading, 'd-block': store.isLoading }"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="position: relative"
      >
        <div
          style="
            position: absolute;
            top: 38%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 24rpx;
            width: 300px;
          "
        >
          <img src="https://www.yuenlongbarrage.hk/img/logo_202507.png" />
        </div>
        <div
          class="modal-content"
          style="border: none; background-color: transparent"
        >
          <div class="spinner-border mx-auto" role="status"></div>
        </div>
      </div>
    </div>
    <div v-if="store.isLoading" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
/* eslint-disable */
import Header from "@/components/header";
import { stores } from "@/utils/store.js";
export default {
  data() {
    return {
      isMobile: false,
      store: stores,
    };
  },
  components: {
    Header,
  },
  watch: {
    "$store.state.scrollTop"(newval) {
      this.$store.commit("setScrollTop", newval);
    },
    $route (to, from) {
      this.openLoading()
      console.log('wathch', to,from)
    }
  },

  mounted() {
    window.addEventListener("scroll", this.scrollToTop);

    let to = localStorage.getItem('to');

    console.log('app.vue to=',to )

    if (!to) {
        localStorage.setItem('to', 'english'); // 默认英文
    }
  },
  created() {

    let to = localStorage.getItem('to');

    console.log('app.vue to=',to )

    if (!to) {
        localStorage.setItem('to', 'english'); // 默认英文
        document.title = "Yuen Long Barrage and Nullah Improvement Schemes";
    }
    else{
      //修改网页标题
      if( to == 'english' ){
        document.title = "Yuen Long Barrage and Nullah Improvement Schemes";
      }
      else if( to == 'chinese_simplified' ){
        document.title = "元朗防洪坝及明渠改善计划 - 官方网站";
      }
      else if( to == 'chinese_traditional' ){
        document.title = "元朗防洪壩及明渠改善計劃 - 官方網站";
      }
    }

  },
  methods: {
    openLoading() {
      stores.updateLoadingStatue(true);
      setTimeout(() => {
        stores.updateLoadingStatue(false);
      }, 3000);
    },
    scrollToTop() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.$store.commit("setScrollTop", scrollTop);
    },
    getEnv() {
      const userAgent = window.navigator.userAgent;
      if (/Mobile|Android|iPhone|iPod|iPad|Windows Phone/i.test(userAgent)) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
  },
};
</script>
<style>
html,
body,
#app {
  padding: 0;
  margin: 0;
  background-color: #ffffff;
  position: relative;
  /* 2025-12-30 取消灰色遮罩 */
  /*filter: grayscale(100%);
    -webkit-filter: grayscale(100%);*/
}
#app {
  height: 100vh;
}

html[lang="en-GB"] body {
  font-family: Helvetica, Arial, "Microsoft JhengHei", 微軟正黑體,
    "Microsoft YaHei", 微软雅黑体, PMingLiU, 新細明體, 宋体, simsun, sans-serif;
}
</style>
